import React from 'react';
import { Button } from 'react-toolbox/lib/button';
import theme from 'components/RemoveButtonTheme.css';

const RemoveButton = props => <Button theme={theme} icon="delete" {...props} />;

export default RemoveButton;
